import { useCallback } from 'react';

import useUserDetails from '@/hooks/useUserDetails';
import { captureEvent } from '@/services/analytics';

type TrackingProps = {
  prompt: string;
  response: any[];
  conversationId: string;
  version: number;
};

export function useRateAnswerTracking({
  prompt,
  response,
  conversationId,
  version
}: TrackingProps) {
  const { userEmail } = useUserDetails();

  const track = useCallback(
    (score: number) => {
      captureEvent('ai_chat_score', {
        email: userEmail,
        prompt,
        response,
        score,
        timestamp: new Date().toISOString(),
        thread_id: conversationId,
        version
      });
    },
    [conversationId, prompt, response, userEmail, version]
  );

  return { track } as const;
}
